import { Tracking } from './../../providers/tracking';
import { MyFirebase } from './../../providers/my-firebase';

import { ElePage } from './../ele/ele';
import { ElesPage } from './../eles/eles';
import { Component } from '@angular/core';
import { ActionSheetController, AlertController, IonicPage, NavController, NavParams } from 'ionic-angular';


/**
 * Cloud edit
 * 
 * Sauvegarde sur pop si ele.name
 * Sur delete demande confirmation
 * 
 */
@IonicPage()
@Component({
  selector: 'page-cloud',
  templateUrl: 'cloud.html',
})
export class CloudPage extends ElePage {


  constructor(public navCtrl: NavController, public navParams: NavParams, 
              public alertCtrl: AlertController, public actionSheetCtrl: ActionSheetController,
              public myFirebase : MyFirebase, public tracking : Tracking) {

    super(navCtrl, navParams);

    this.encodeTags();
  }

  ionViewDidEnter() {
    this.tracking.view(this);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CloudPage');
    super.ionViewDidLoad();
  }


  ionViewWillLeave() {

    //this.onAddOrUpdateEle();
    if (this.ele.name) this.parentPage.addOrUpdate(this.eleId, this.ele);
  }



  // onCloudLicIds() {
  //   this.navCtrl.push(InfoCloudDetailPage, {parent:this, eleId: this.eleId, ele:this.ele });    
  // }
  // onCloudAttachLicIds() {
  //   this.navCtrl.push(AttachLicidPage, {cloudId: this.eleId });
  // }


  
  onAddTag() {

    if (!this.ele.tags) this.ele['tags'] = new Array();
    this.ele.tags.push( {tag: '', value: '' });
  }

  onRemoveTag(indexTag) {
console.log('onRemoveTag:' + indexTag);
    this.ele.tags.splice(indexTag, 1);
  }


  onAddOrUpdateEle() {    

    this.decodeTags();
    super.onAddOrUpdateEle();
  }


  onDeleteEle() {

    let confirm = this.alertCtrl.create({
      title: 'Delete this cloud ?',
      message: 'Are you sure to delete this cloud ?',
      buttons: [
        {
          text: 'No',
          handler: () => { console.log('No'); }
        },
        {
          text: 'Yes',
          handler: () => {
            
            this.ele.name = null;
            this.navCtrl.pop();
            return this.parentPage.myList.delete(this.eleId);
            
          }
        }
      ]
    });
    confirm.present();

  }


  encodeTags() {

    if (!this.ele) return;
    if (!this.ele.tags) return;
    
    // this.ele.tags.forEach( (ele) => {
    //   ele.value = ele.value.replace(/\n/, "\\n");
    // });
  }

  decodeTags() {
  
    if (!this.ele) return;
    if (!this.ele.tags) return;

    //  this.ele.tags.forEach( (ele) => {
    //   ele.value = ele.value.replace("\\n", '\n');
    // });
  }
}



// WEBPACK FOOTER //
// ./src/pages/cloud/cloud.ts